import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { BackButton } from 'src/components/shared/BackButton'
import { ADMIN_ROUTES } from 'src/constants/routes'

interface Props {
  title: string
  issueId: string
}

const AppPlaceholderPageComponent = ({ title, issueId }: Props) => {
  return (
    <main css={tw`flex flex-1 items-center justify-center overflow-y-auto px-6 py-8`}>
      <div
        data-testid="app-placeholder"
        css={tw`w-full max-w-[420px] rounded-xl border border-solid border-shades-200 bg-shades-0 p-6 text-center`}
      >
        <Typography variant="h3" css={tw`text-shades-900`}>
          {title}
        </Typography>
        <Typography css={tw`mb-4 mt-2 text-sm text-shades-500`}>
          This tool has not been built yet. It is tracked as {issueId}.
        </Typography>
        <div css={tw`flex justify-center`}>
          <BackButton label="Back to all tools" to={ADMIN_ROUTES.LAUNCHER_URL} />
        </div>
      </div>
    </main>
  )
}

export const AppPlaceholderPage = memo(AppPlaceholderPageComponent)
